import React, { useEffect, useState } from "react";
import Mainimage from "../../Images/login4.png";
import Flag from "../../Images/flag.png";
import bgImage from "../../Images/abstract-paper-background-concept.jpg";
import axios from "../../axios";
import { useTranslation } from "react-i18next";
import { gapi } from "gapi-script";
import { useNavigate } from "react-router-dom";
import { Riple } from "react-loading-indicators";
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";

const Signin2 = () => {
  const [t, i18n] = useTranslation();
  const navigate = useNavigate();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [showActivationScreen, setShowActivationScreen] = useState(false);
  const [videodata, setVideodata] = useState(
    "https://www.youtube.com/watch?v=gACrWBPWsMM",
  );
  const [showmail, setShowmail] = useState(false);
  const [smail, setSmail] = useState("");
  const [dialog, setDialog] = useState({
    title: "Maintenance",
    message: `Learn2Earn24x7 is currently down for maintenance. We expect to be back in a couple of hours. Thanks for your patience.`,
  });
  const [signingtitle, setSigningtitle] = useState(false);
  const [terms, setTerms] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [mobile, setMobile] = useState("");
  const [isOtpOpen, setIsOtpOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");

  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId:
          "42381582230-itun71s3lnvhb9f4eaqa2t5sf4idu4ta.apps.googleusercontent.com",
        scope: "email",
      });
    }
    gapi.load("client:auth2", start);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const reason = params.get("reason");

    if (reason === "another_device_login") {
      toast.info(
        "You were logged out because you logged in on another device.",
      );
    }

    // Capture referral code from URL and persist it
    const refCode = params.get("ref");
    if (refCode) {
      localStorage.setItem("pendingRefCode", refCode.toUpperCase());
    }
  }, []);

  const getLocationState = async () => {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      return data.region;
    } catch (error) {
      return null;
    }
  };

  const getDeviceInfo = () => {
    const ua = navigator.userAgent.toLowerCase();
    const width = window.innerWidth;

    let deviceType = "laptop";

    if (/ipad|iphone|ipod/.test(ua)) deviceType = "ios";
    else if (width <= 768) deviceType = "mobile";
    else if (width <= 1024) deviceType = "tablet";

    return {
      deviceCategory: deviceType,
      deviceId: crypto.randomUUID(),
      deviceType,
      deviceName: navigator.platform,
    };
  };

  const handleLoginSuccess = async (response) => {
    const tokenId = response?.credential;
    const deviceInfo = getDeviceInfo();
    const IPstate = await getLocationState();
    if (tokenId) {
      axios
        .post("login", {
          token: tokenId,
          platform: "web",
          deviceInfo,
          IPstate,
          loginType: "google",
        })
        .then((response) => {
          const data = response;
          console.log(data.data.token);
          console.log(deviceInfo, "device info");
          if (data) {
            localStorage.setItem("token", data?.data?.token);
            if (!data?.data?.user?.onHold && !data?.data?.user?.deleted) {
              if (
                !data?.data?.user?.mobile ||
                data?.data?.user?.mobile?.length === 0
              ) {
                navigate("/login-info");
              } else {
                navigate("/dash");
              }
            } else {
              setDialogOpen(true);
            }
          }
        })
        .catch(() => {
          setDialogOpen(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setDialogOpen(true);
    }
  };

  const handleLoginFailure = () => {
    console.error("Login Failed");
    setIsLoading(false);
  };

  const [googleLoginWidth, setGoogleLoginWidth] = useState(358);

  useEffect(() => {
    const handleResize = () => {
      setGoogleLoginWidth(window.innerWidth <= 480 ? 300 : 358);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const stHinmdi = () => {
    if (i18n.language === "en") {
      i18n.changeLanguage("hi");
      setVideodata("https://www.youtube.com/watch?v=CKx3aQO8CbM");
    } else if (i18n.language === "hi") {
      i18n.changeLanguage("en");
      setVideodata("https://www.youtube.com/watch?v=gACrWBPWsMM");
    }
  };

  const handleSignInClick = () => {
    setIsLoading(true);
    const auth2 = gapi.auth2?.getAuthInstance();
    auth2?.signIn().then(
      (response) => {
        handleLoginSuccess(response);
      },
      (error) => {
        handleLoginFailure(error);
      },
    );
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 4) {
      setOtpError("Enter valid 4 digit OTP");
      return;
    }

    try {
      setIsLoading(true);

      // 1️⃣ Verify OTP
      await axios.post("/verify-otp", {
        phoneNumber: mobile,
        otp,
      });

      // 2️⃣ Login after OTP verify
      const deviceInfo = getDeviceInfo();
      const IPstate = await getLocationState();

      const res = await axios.post("/mobileLogin", {
        mobile,
        platform: "web",
        deviceInfo,
        IPstate,
      });

      const { token, user } = res.data;

      // 3️⃣ Save token
      if (token) {
        localStorage.setItem("token", token);
      }

      toast.success("Login successful");
      setIsOtpOpen(false);

      // 4️⃣ ✅ CONDITIONAL REDIRECT
      if (user?.mobile && user?.email) {
        navigate("/dash"); // profile complete
      } else {
        navigate("/login-info"); // profile incomplete
      }
    } catch (err) {
      setOtpError(err?.response?.data?.message || "Invalid OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const otpArr = otp.split("");
    otpArr[index] = value;

    const newOtp = otpArr.join("").slice(0, 4);
    setOtp(newOtp);
    setOtpError("");

    // next box focus
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const otpArr = otp.split("");

      // current box empty hai → pichla box clear + focus
      if (!otpArr[index] && index > 0) {
        otpArr[index - 1] = "";
        setOtp(otpArr.join(""));
        document.getElementById(`otp-${index - 1}`).focus();
      }
      // current box me value hai → wahi clear
      else {
        otpArr[index] = "";
        setOtp(otpArr.join(""));
      }

      setOtpError("");
    }
  };

  const [resendTimer, setResendTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  useEffect(() => {
    if (!isOtpOpen) return;

    setResendTimer(30);
    setCanResend(false);

    const interval = setInterval(() => {
      setResendTimer((t) => {
        if (t <= 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return t - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpOpen]);

  const handleResendOtp = async () => {
    if (!canResend) return;

    try {
      await axios.post("/generate-otp", { mobile });
      toast.success("OTP resent");
      setResendTimer(30);
      setCanResend(false);
    } catch {
      toast.error("Failed to resend OTP");
    }
  };

  const handleChangeNumber = () => {
    setIsOtpOpen(false); // OTP modal close
    setOtp(""); // OTP clear
    setOtpError(""); // Error clear
  };

  const handleRequestOtp = async () => {
    if (mobile.length !== 10) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      setIsLoading(true);

      await axios.post("/generate-otp", {
        phoneNumber: mobile,
      });

      setOtp("");
      setOtpError("");
      setIsOtpOpen(true);
      toast.success("OTP sent successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };

  // --------- UI (IMAGE) -------------
  return (
    <div className="w-full min-h-screen bg-bgBlue flex flex-col sm:flex-row items-center justify-center px-4">
      <div className="flex justify-center sm:justify-start mb-8 sm:mb-0">
        <img src={Mainimage} alt="Learn2Earn24x7" className="w-40 sm:w-80" />
      </div>

      <div className="w-full max-w-md sm:ml-16 flex flex-col items-center ">
        {/* Heading */}
        <h1 className="text-white text-3xl font-bold ">Login Account</h1>
        <p className="text-gray-300 mt-2 text-sm">
          Hello, Welcome Back to our account
        </p>

        {/* Phone Input (UI purpose, अभी functionality नहीं बदली) */}
        <div className="w-96 mt-8 h-10 flex items-center border border-white/40 rounded-full px-4 py-3">
          {/* Flag + Code */}
          <div className="flex items-center pr-3 border-r border-white/30 gap-2">
            <img
              src={Flag}
              alt="India Flag"
              className="w-6 h-4 rounded-sm object-cover"
            />
            <span className="text-white text-sm">+91</span>
          </div>

          {/* Number */}
          <input
            type="tel"
            placeholder="0123456789"
            value={mobile}
            onChange={(e) => {
              // केवल digits और max 10
              const v = e.target.value.replace(/\D/g, "").slice(0, 10);
              setMobile(v);
            }}
            className="flex-1 bg-transparent text-white text-sm pl-3 placeholder-gray-400 border-none outline-none focus:ring-0"
          />
        </div>

        {/* Request OTP Button (you can later connect your OTP API) */}
        <button
          onClick={handleRequestOtp}
          className="w-96 h-10 mt-6 rounded-full bg-[#ff7a1a] text-white font-semibold"
        >
          Request OTP
        </button>

        {isOtpOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
            {/* backdrop */}
            <div
              className="absolute inset-0 bg-black/50"
              onClick={() => setIsOtpOpen(false)}
            />
            {/* modal */}
            <div className="relative z-10 w-[90%] max-w-sm rounded-2xl bg-bgBlue border border-2 border-white p-6 shadow-2xl text-white">
              <h3 className="text-xl font-bold text-center">Enter OTP</h3>
              <p className="text-sm text-center mt-1">
                OTP sent to +91 {mobile}
              </p>

              <div className="mt-5 flex justify-center gap-3">
                {[0, 1, 2, 3].map((i) => (
                  <input
                    key={i}
                    id={`otp-${i}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={otp[i] || ""}
                    autoFocus={i === 0}
                    onChange={(e) => handleOtpChange(e.target.value, i)}
                    onKeyDown={(e) => handleOtpKeyDown(e, i)}
                    className="h-12 w-12 text-center text-lg font-bold bg-violet
                              border border-slate-300 rounded-xl bg-bgBlue
                              outline-none focus:ring-2 focus:ring-orange-400"
                  />
                ))}
              </div>

              {otpError && (
                <p className="text-red-600 text-sm mt-2 text-center">
                  {otpError}
                </p>
              )}

              <div className="mt-5 flex gap-3">
                <button
                  onClick={() => setIsOtpOpen(false)}
                  className="w-1/2 py-2.5 rounded-xl bg-bgBlue text-white font-semibold border "
                >
                  Cancel
                </button>
                <button
                  onClick={handleVerifyOtp}
                  className="w-1/2 py-2.5 rounded-xl bg-[#ff7a1a] text-white font-semibold hover:bg-[#ff8b35]"
                >
                  Verify
                </button>
              </div>

              <div className="mt-4 flex justify-center gap-4 text-sm">
                {canResend ? (
                  <button
                    onClick={handleResendOtp}
                    className="text-orange-400 font-semibold hover:underline"
                  >
                    Resend OTP
                  </button>
                ) : (
                  <span className="flex gap-2">
                    Resend OTP in
                    <span className="text-orange-400 font-semibold">
                      {resendTimer}s
                    </span>
                  </span>
                )}

                <span className="text-gray-400">|</span>

                <button
                  onClick={handleChangeNumber}
                  className="text-white/80 hover:underline"
                >
                  Change Number
                </button>
              </div>
            </div>
          </div>
        )}

        {/* OR Separator */}
        <div className="flex items-center gap-2 my-5 w-full">
          <div className="flex-1 h-px bg-white/30" />
          <span className="text-white/80 text-sm">or</span>
          <div className="flex-1 h-px bg-white/30" />
        </div>

        {/* Google Login (FUNCTIONALITY SAME) */}
        <div className="flex justify-center w-full">
          {isLoading ? (
            <Riple color="#ffffff" size="medium" text="" textColor="" />
          ) : (
            <GoogleLogin
              onSuccess={handleLoginSuccess}
              onError={handleLoginFailure}
              width={380}
              size="large"
              shape="circle"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Signin2;
